import BigNumber from 'bignumber.js'

export const formatNumber = (newValue: string | number, flag?:"en" | string) => {
    if (new BigNumber(newValue).isNaN()) {
        return '0'
    }
    return Intl.NumberFormat("en-US",{  maximumFractionDigits: 2})
    .format(new BigNumber(newValue).decimalPlaces(0,1).toNumber())
}
